export default function VerifiedIco({ size }) {
  return (
    <svg
      width={size || "22"}
      height={size || "22"}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.148438 8.05067C0.148438 4.07903 3.36809 0.859375 7.33973 0.859375V0.859375C11.3114 0.859375 14.531 4.07903 14.531 8.05067V8.05067C14.531 12.0223 11.3114 15.242 7.33973 15.242V15.242C3.36809 15.242 0.148438 12.0223 0.148438 8.05067V8.05067Z"
        fill="#DCFAE6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.3942 5.28849L6.10334 9.42948L4.96472 8.21295C4.75498 8.01519 4.42537 8.0032 4.18566 8.171C3.95195 8.34479 3.88603 8.65042 4.02985 8.89612L5.37822 11.0895C5.51006 11.2932 5.73779 11.4191 5.99547 11.4191C6.24118 11.4191 6.47489 11.2932 6.60673 11.0895C6.82247 10.8078 10.9395 5.89975 10.9395 5.89975C11.4788 5.34841 10.8256 4.863 10.3942 5.28249V5.28849Z"
        fill="#079455"
      />
    </svg>
  );
}
